const headerData = [
  {
    prop: "id",
    label: "序号",
    columnwidth: 50,
  },
  {
    prop: "StatusName",
    label: "状态",
    columnwidth: 80,
  },
  {
    prop: "RepeatMessage",
    label: "重复判断",
    columnwidth: 150,
  },
  {
    prop: "InvClassName",
    label: "产品线",
    columnwidth: 80,
  },
  {
    prop: "MFName",
    label: "生产厂商",
    columnwidth: 250,
  },
  {
    prop: "SalesManName",
    label: "销售员",
    columnwidth: 150,
  },
  {
    prop: "CreatorName",
    label: "创建人",
    columnwidth: 95,
  },
  {
    prop: "ProviderName",
    label: "授权经销商",
    columnwidth: 200,
  },
  {
    prop: "InvNameString",
    label: "授权产品",
    columnwidth: 200,
  },
  {
    prop: "RelationInvNameString",
    label: "关联产品",
    columnwidth: 200,
  },
  {
    prop: "AuthorityCode",
    label: "授权编号",
    columnwidth: 160,
  },
  {
    prop: "StartDate",
    label: "授权有效期（开始）",
    columnwidth: 200,
  },

  {
    prop: "EndDate",
    label: "授权有效期（结束）",
    columnwidth: 130,
  },

  {
    prop: "Remark",
    label: "备注",
    columnwidth: 200,
  },
  {
    prop: "RejecterName",
    label: "驳回人",
    columnwidth: 160,
  },
  {
    prop: "RejectReason",
    label: "驳回原因",
    columnwidth: 160,
  },
  {
    prop: "RejectTime",
    label: "驳回时间",
    columnwidth: 160,
  },
  {
    prop: "RevokeReason",
    label: "撤回原因",
    columnwidth: 150,
  },
  {
    prop: "NeedBossApprovalName",
    label: "是否老板审批",
    columnwidth: 130,
  },
  {
    prop: "CreateTime",
    label: "创建日期",
    columnwidth: 110,
  },
  {
    prop: "ApproverName",
    label: "审核人",
    columnwidth: 110,
  },
  {
    prop: "ApproveTime",
    label: "审核时间",
    columnwidth: 110,
  },
];
export default headerData;
